import setRef from './setRef';

export const setMultipleRef =
  (...args) =>
  ref =>
    args.forEach(refHook => setRef(refHook, ref));
